import { Button, Modal } from "antd";
import "./MessageRemoveModal.scss";
import { useInfoUser } from "../../../store/UserStore";
const MessageRemoveModal = ({ onCancel, open, onConfirm }) => {
  const { languageMap } = useInfoUser();
  return (
    <Modal
      title={
        languageMap?.[`modal.wantToRemoveMessage`] ??
        "Do you want to remove this message?"
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      closeIcon={null}
    >
      <div className="message-remove-modal">
        <Button
          className="button bg-[#1677ff] text-[white]"
          onClick={onConfirm}
        >
          {languageMap?.["modal.ok"] ?? "Ok"}
        </Button>
        <Button className="button bg-[#ff4d4f] text-[white]" onClick={onCancel}>
          {languageMap?.["modal.cancel"] ?? "Cancel"}
        </Button>
      </div>
    </Modal>
  );
};

export { MessageRemoveModal };
